// Modules
import React from 'react'

// Component: Utility > Application error
// WARNING: This is the last-resort fallback of the error boundary, so it must not depend on
// the router, the translations, the application state or any stylesheet. Keep it self-contained.
function ApplicationError () {
	// Render
	return (
		<div
			role="alert"
			style={{
				alignItems: 'center',
				display: 'flex',
				flexDirection: 'column',
				fontFamily: 'Inter, system-ui, sans-serif',
				gap: '16px',
				justifyContent: 'center',
				minHeight: '100vh',
				padding: '24px',
				textAlign: 'center'
			}}>
			<h1 style={{ fontSize: '20px', fontWeight: 600, margin: 0 }}>Something went wrong</h1>
			<p style={{ margin: 0, maxWidth: '32em', opacity: 0.75 }}>
				The application could not be loaded. Reloading the page usually resolves it.
			</p>
			<button
				type="button"
				onClick={() => window.location.reload()}
				style={{
					background: '#7b8c9d',
					border: 0,
					borderRadius: '4px',
					color: 'white',
					cursor: 'pointer',
					fontSize: '14px',
					padding: '10px 20px'
				}}>
				Reload page
			</button>
		</div>
	)
}

// Export
export default ApplicationError
